import Auth from "services/Auth";
import { getLanguage } from "config/language";
import { getUser } from "config/user";
import moment from "moment";

// route active checking
export function hasActive(path = "", f) {
	if (path.slice(0) == "*" && path.slice(-1) == "*")
		return (
			f.search(new RegExp("\\b" + path.substring(0, path.length - 1))) &&
			"active"
		);
	else if (path.slice(0) == "*")
		return (
			f.search(new RegExp(path.substring(0, path.length - 1) + "\\b")) ===
				-1 && "active"
		);
	else if (path.slice(-1) == "*")
		return (
			f.search(new RegExp(path.substring(0, path.length - 1) + "\\b")) ===
				0 && "active"
		);
	else return f === path && "active";
}

export async function authOtpSend(phoneNumber, country, countryCode) {
	let req_body = {
		phone_number: (countryCode + phoneNumber).trim(),
		country,
	};
	try {
		// return await Auth.resendOptTokenWithToken(req_body);
		return await Auth.resendOptToken(req_body);

		// if (response.status === 200)
		//   //   toast.info(response.message);
		//   response.message;
		//  else
		//   {
		//     message: "Your phone number not verify yet please resend token",
		//     success: false,
		//   }
	} catch (e) {
		console.log(e);
	}
}

export function addStatusClass(status) {
	switch (status) {
		case "Placed":
			return "placed";
		case "Accepted":
			return "accepted";
		case "Delivered":
			return "delivered";
		case "Paid":
			return "paid";
		case "Cancel":
			return "cancel";
		case "Partially_Paid":
			return "partial-payment";
		case "Partially_Delivered":
			return "partial-delivery";
		case "Returned_Items":
			return "return";
		case "Scheduled For Delivery":
			return "scDelivery";
		case "Delivery Failed":
			return "delivery-failed";
		default:
			return "FFC227-1000";
		// break;
	}
}

var finalEnglishToBangleNumber = {
	0: "০",
	1: "১",
	2: "২",
	3: "৩",
	4: "৪",
	5: "৫",
	6: "৬",
	7: "৭",
	8: "৮",
	9: "৯",
};

String.prototype.getBangleDigit = function () {
	var retStr = this;
	for (var x in finalEnglishToBangleNumber) {
		retStr = retStr.replace(
			new RegExp(x, "g"),
			finalEnglishToBangleNumber[x]
		);
	}
	return retStr;
};

export const digitChanger = function (value) {
	if (getLanguage() === "bn") {
		return String(value).getBangleDigit();
	} else {
		return String(value);
	}
};

var englishToBangleMonth = {
	Jan: "জানুয়ারী",
	Feb: "ফেব্রুয়ারি",
	Mar: "মার্চ",
	Apr: "এপ্রিল",
	May: "মে",
	Jun: "জুন",
	Jul: "জুলাই",
	Aug: "আগস্ট",
	Sep: "সেপ্টেম্বর",
	Oct: "অক্টোবর",
	Nov: "নভেম্বর",
	Dec: "ডিসেম্বর",
};
String.prototype.getBangleMonth = function () {
	var retStr = this;
	for (var x in englishToBangleMonth) {
		retStr = retStr.replace(new RegExp(x, "g"), englishToBangleMonth[x]);
	}
	return retStr;
};

export const monthChanger = function (value) {
	if (getLanguage() === "bn") {
		return String(value).getBangleMonth();
	} else {
		return String(value);
	}
};

var englishToBangle = {
	BDT: "৳",
	SGD: "$",
};
String.prototype.getBangle = function () {
	var retStr = this;
	for (var x in englishToBangle) {
		retStr = retStr.replace(new RegExp(x, "g"), englishToBangle[x]);
	}
	return retStr;
};

export const translator = function (value) {
	if (getUser().Country === "Bangladesh") {
		return String(value).getBangle();
	} else if (getUser().Country === "Singapore") {
		return String(value).getBangle();
	} else {
		return String(value);
	}
};

var status = {
	Placed: "স্থাপিত",
	Accepted: "গ্রহণ",
	Cancel: "বাতিল",
	Partially_Paid: "আংশিক পরিশোধ",
	Partially_Delivered: "আংশিক ডেলিভারি",
	Delivered: "ফুল ডেলিভারি",
	Paid: "ফুল পরিশোধ",
	Returned_Items: "ফেরত পণ্য",
	"Scheduled For Delivery": "ডেলিভারির জন্য নির্ধারিত",
	"Delivery Failed": "ডেলিভারি ব্যর্থ হয়েছে",
};
String.prototype.getBangleStatus = function () {
	var retStr = this;
	for (var x in status) {
		retStr = retStr.replace(new RegExp(x, "g"), status[x]);
	}
	return retStr;
};

export const statusTranslator = function (value) {
	if (getUser().Country === "Bangladesh") {
		return String(value).getBangleStatus();
	} else {
		return String(value);
	}
};
// export const weekChanger = function (value) {
// 	if (getLanguage() === "bn") {
// 		return String(value).getBangleWeek();
// 	} else {
// 		return String(value);
// 	}
// };
export const stringCount = function (str, count) {
	if (String(str).length <= count) {
		return str;
	}
	return str.slice(0, count) + "...";
};

export function numberWithCommas(number) {
	// Handle if input is not a number
	if (isNaN(number) && typeof number !== "string") {
		return "NaN";
	}

	// Extract currency symbol if present
	let currencySymbol = "";
	let numStr = String(number);
	if (numStr.startsWith("$")) {
		currencySymbol = "$";
		numStr = numStr.substring(1);
	}

	// Convert to number and format
	const num = Number(numStr);
	if (isNaN(num)) {
		return "NaN";
	}

	// Format with 2 decimal places
	const formattedNumber = num.toFixed(2);

	// Split into integer and decimal parts
	const [integerPart, decimalPart] = formattedNumber.split(".");

	// Add commas to integer part
	const integerWithCommas = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");

	// Combine parts with currency symbol if present
	const result = decimalPart
		? `${currencySymbol}${integerWithCommas}.${decimalPart}`
		: `${currencySymbol}${integerWithCommas}`;

	return result;
}

export const dateTimeFormatter = function (value) {
	let start, end;
	switch (value) {
		case "today":
			start = moment().startOf("day").toString();
			end = moment().endOf("day").toString();
			break;
		case "yesterday":
			start = moment().subtract(1, "days").startOf("day").toString();
			end = moment().subtract(1, "days").endOf("day").toString();
			break;
		case "week":
			start = moment().startOf("isoWeek").toString(); // Start from Monday of current week
			end = moment().endOf("day").toString(); // End at today
			break;
		case "lastWeek":
			start = moment().subtract(1, "weeks").startOf("isoWeek").toString();
			end = moment().subtract(1, "weeks").endOf("isoWeek").toString();
			break;
		case "month":
			start = moment().startOf("month").toString();
			end = moment().endOf("month").toString();
			break;
		case "lastMonth":
			start = moment().subtract(1, "months").startOf("month").toString();
			end = moment().subtract(1, "months").endOf("month").toString();
			break;
		case "year":
			start = moment().startOf("year").toString();
			end = moment().endOf("year").toString();
			break;
		case "lastYear":
			start = moment().subtract(1, "years").startOf("year").toString();
			end = moment().subtract(1, "years").endOf("year").toString();
			break;
		case "custom":
			start = moment().startOf("day").toString();
			end = moment().endOf("day").toString();
			break;
		case "selectDay":
			start = moment().startOf("day").toString();
			end = moment().endOf("day").toString();
			break;
		default:
			break;
	}
	return { start, end };
};
